import {toAbsoluteUrl} from '../../../../_gori/helpers'

export function Discounts() {
  return (
    <section className='discounts'>
      <div className='container'>
        <div className='d-flex flex-row flex-wrap justify-content-center gap-9 align-items-center mx-auto mb-22'>
          <img
            className='animated-image'
            src={toAbsoluteUrl('/media/gori/landing/usps-discount.svg')}
            alt='USPS logo'
            width='160'
            height='175'
            loading='lazy'
            decoding='async'
          />
          <img
            className='animated-image'
            src={toAbsoluteUrl('/media/gori/landing/fedex-discount.svg')}
            alt='FedEx logo'
            width='160'
            height='175'
            loading='lazy'
            decoding='async'
          />
          <img
            className='animated-image'
            src={toAbsoluteUrl('/media/gori/landing/ups-discount.svg')}
            alt='UPS logo'
            width='160'
            height='175'
            loading='lazy'
            decoding='async'
          />
          <img
            className='animated-image'
            src={toAbsoluteUrl('/media/gori/landing/dhl-discount.svg')}
            alt='DHL logo'
            width='160'
            height='175'
            loading='lazy'
            decoding='async'
          />
        </div>
      </div>
    </section>
  )
}
